(function() {
  var variantMediaEl = document.getElementById('tt-variant-media');
  var variantMedia = [];
  if (variantMediaEl) {
    try {
      variantMedia = JSON.parse(variantMediaEl.textContent);
    } catch (e) {
      variantMedia = [];
    }
  }

  var ttUserSelectedVariantId = null;
  var ttInitialVariantUrlApplied = false;



if (window.__ttIsHandbagProduct && document.body) {
    document.body.classList.add('tt-handbag-product');
  }
  window.__ttHandbagAtcLabel = 'Add to Cart';
  window.__ttDollAtcLabel = 'BUY NOW';

  function isSimpleProductPage() {
    return window.__ttIsTumblerProduct || window.__ttIsDollProduct || window.__ttIsStrawProduct;
  }

  function getHandbagAtcLabel() {
    return window.__ttHandbagAtcLabel || 'Add to Cart';
  }

  function getDollAtcLabel() {
    return window.__ttDollAtcLabel || 'BUY NOW';
  }

  function applyHandbagAtcLabels() {
    if (!window.__ttIsHandbagProduct) return;
    var label = getHandbagAtcLabel();
    document.querySelectorAll('.product__atc [data-buy-button], .tt-sticky-bar__atc[data-buy-button]').forEach(function(btn) {
      btn.dataset.originalText = label;
    });
  }

  function applyDollAtcLabels() {
    if (!window.__ttIsDollProduct) return;
    var label = getDollAtcLabel();
    document.querySelectorAll('.product__atc [data-buy-button]').forEach(function(btn) {
      btn.dataset.originalText = label;
      var text = btn.querySelector('[data-button-text]');
      if (text) text.textContent = label;
      btn.disabled = false;
      btn.removeAttribute('disabled');
    });
  }

  function getDollDockQtyInput() {
    return document.querySelector('#tt-doll-checkout-dock [data-qty-input], .tt-doll-checkout-dock [data-qty-input], .product__atc [data-qty-input]');
  }

  function getDollDockQty() {
    var input = getDollDockQtyInput();
    var val = input ? parseInt(input.value, 10) : NaN;
    return val > 0 ? val : 1;
  }

  function ensureDollFormSyncFields(form) {
    if (!form) return { qty: null, id: null };
    var qtySync = form.querySelector('#tt-doll-qty-sync');
    if (!qtySync) {
      qtySync = document.createElement('input');
      qtySync.type = 'hidden';
      qtySync.name = 'quantity';
      qtySync.id = 'tt-doll-qty-sync';
      form.appendChild(qtySync);
    }
    var idSync = form.querySelector('#tt-doll-id-sync');
    if (!idSync) {
      idSync = document.createElement('input');
      idSync.type = 'hidden';
      idSync.name = 'id';
      idSync.id = 'tt-doll-id-sync';
      form.appendChild(idSync);
    }
    return { qty: qtySync, id: idSync };
  }

  function syncDollCheckoutToForm() {
    if (!window.__ttIsDollProduct) return;
    var form = getProductForm();
    if (!form) return;

    preselectDollVariant(form);
    var vid = defaultVariantId() || resolveVariantId();
    var qty = getDollDockQty();
    var syncFields = ensureDollFormSyncFields(form);
    if (syncFields.qty) syncFields.qty.value = qty;
    if (syncFields.id && vid) syncFields.id.value = vid;

    var formVariant = form.querySelector('[data-bstr-variant-input], input[name="id"]:not(#tt-doll-id-sync)');
    if (formVariant && vid) {
      formVariant.value = vid;
      formVariant.setAttribute('value', vid);
    }

    var dockQty = getDollDockQtyInput();
    if (dockQty) {
      dockQty.value = qty;
      if (dockQty.getAttribute('name') === 'quantity') {
        dockQty.removeAttribute('name');
      }
    }

    var dockVariant = document.querySelector('#tt-doll-checkout-dock [data-bstr-variant-input], .product__atc [data-bstr-variant-input]');
    if (dockVariant && vid) {
      dockVariant.value = vid;
      dockVariant.setAttribute('value', vid);
      dockVariant.removeAttribute('name');
    }
  }

  function preselectDollVariant(form) {
    if (!window.__ttIsDollProduct) return false;
    form = form || getProductForm();
    var vid = defaultVariantId() || resolveVariantId();
    if (!vid) return false;

    var BT = window.BoosterTheme;
    var pid = getProductId();
    if (BT && BT.swatches && pid) {
      try {
        BT.swatches.setProductVariant(pid, vid);
      } catch (e) {}
    }

    var idInput = form ? getVariantInput(form) : null;
    if (idInput) {
      idInput.value = vid;
      idInput.setAttribute('value', vid);
    }

    var dockVariant = document.querySelector('#tt-doll-checkout-dock [data-bstr-variant-input], .product__atc [data-bstr-variant-input]');
    if (dockVariant) {
      dockVariant.value = vid;
      dockVariant.setAttribute('value', vid);
      dockVariant.removeAttribute('name');
    }
    return true;
  }

  function bindDollBuyButtons() {
    if (!window.__ttIsDollProduct) return;
    document.querySelectorAll('.product__atc [data-buy-button], .tt-sticky-bar__atc[data-buy-button]').forEach(function(btn) {
      if (btn.dataset.ttDollBuyBound === '1') return;
      btn.dataset.ttDollBuyBound = '1';
      btn.removeAttribute('onclick');
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        addDollProductToCartDirect(e, btn);
      }, true);
    });
  }

  function initDollProductPage() {
    if (!window.__ttIsDollProduct) return;
    preselectDollVariant();
    syncDollCheckoutToForm();
    applyDollAtcLabels();
    installDollCheckoutSync();
    bindDollBuyButtons();
    updateAtcState();
  }

  function installDollCheckoutSync() {
    if (!window.__ttIsDollProduct || window.__ttDollCheckoutSync) return;
    window.__ttDollCheckoutSync = true;

    document.addEventListener('click', function(e) {
      if (!window.__ttIsDollProduct) return;
      if (e.target.closest('.quantity--input__button')) {
        setTimeout(syncDollCheckoutToForm, 0);
        setTimeout(syncDollCheckoutToForm, 80);
      }
      if (e.target.closest('.shopify-payment-button, .shopify-payment-button__button, .shopify-payment-button__more-options')) {
        syncDollCheckoutToForm();
      }
    }, true);

    document.addEventListener('change', function(e) {
      if (!window.__ttIsDollProduct) return;
      if (e.target && e.target.matches('[data-qty-input]')) syncDollCheckoutToForm();
    }, true);

    document.addEventListener('input', function(e) {
      if (!window.__ttIsDollProduct) return;
      if (e.target && e.target.matches('[data-qty-input]')) syncDollCheckoutToForm();
    }, true);
  }





  function redirectToCart() {
    var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'cart'
      : '/cart';
    window.location.replace(cartUrl);
  }

  function getUniqueVariants() {
    var seen = {};
    var list = [];
    for (var i = 0; i < variantMedia.length; i++) {
      var v = variantMedia[i];
      if (!v || !v.id) continue;
      if (seen[v.id]) continue;
      seen[v.id] = true;
      list.push(v);
    }
    return list;
  }































  function updateMainImageForVariant(variantId) {
    var match = getVariantMatch(variantId);
    if (!match || !match.image) return;
    updateVisibleSlideImage(match.image);
  }

  function variantLabel(v) {
    if (!v || !v.options || !v.options.length) return 'Color';
    return v.options[0];
  }

  function variantThumbUrl(v) {
    if (!v || !v.image) return '';
    return v.image.replace(/width=\d+/, 'width=120');
  }



  function isInsideGallery(node) {
    return !!(node && node.closest && node.closest('.gallery, .gallery__default'));
  }











  function lockVariantGalleryHeight() {
    var holder = document.querySelector('.slider--product-holder--variant-colors, .gallery__default .slider--product-holder');
    if (!holder) return;
    var target = holder.querySelector('.slide--product img');
    var height = 'min(480px, 52vh)';
    if (window.matchMedia('(max-width: 767px)').matches) {
      height = 'min(72vw, 420px)';
    }
    holder.style.height = height;
    holder.style.minHeight = height;
    holder.style.maxHeight = height;
    holder.querySelectorAll('.slide--product').forEach(function(slide) {
      slide.style.height = height;
      slide.style.minHeight = height;
      slide.style.maxHeight = height;
    });
    holder.querySelectorAll('.slide--product img').forEach(function(img) {
      img.style.height = height;
      img.style.minHeight = height;
      img.style.maxHeight = height;
      img.style.width = '100%';
      img.style.objectFit = 'contain';
    });
    if (target) {
      holder.dataset.ttLockedHeight = height;
    }
  }

  function refreshVariantGalleryUi() {
    syncGalleryVariantLabels();
    lockVariantGalleryHeight();
  }

  function syncGalleryVariantLabels() {
    document.querySelectorAll('.gallery__thumbnails--variant-colors .gallery__thumbnail[data-variant-id]').forEach(function(thumb) {
      var vid = thumb.getAttribute('data-variant-id');
      var labelText = thumb.getAttribute('data-variant-label') || '';
      if (!labelText && vid) {
        var match = getVariantMatch(vid);
        if (match) labelText = variantLabel(match);
      }
      if (!labelText) return;

      var labelEl = thumb.querySelector('.tt-gallery-thumb__label');
      if (!labelEl) {
        labelEl = document.createElement('span');
        labelEl.className = 'tt-gallery-thumb__label';
        thumb.appendChild(labelEl);
      }
      labelEl.textContent = labelText;

      var img = thumb.querySelector('img');
      if (!img) return;

      var imgWrap = thumb.querySelector('.tt-gallery-thumb__img-wrap');
      if (!imgWrap) {
        imgWrap = document.createElement('span');
        imgWrap.className = 'tt-gallery-thumb__img-wrap';
        thumb.insertBefore(imgWrap, thumb.firstChild);
      }
      if (img.parentNode !== imgWrap) {
        imgWrap.appendChild(img);
      }
      if (imgWrap !== thumb.firstElementChild) {
        thumb.insertBefore(imgWrap, thumb.firstChild);
      }
    });
  }
















  function scheduleGallerySyncForVariant(variantId) {
    rememberUserVariantId(variantId);
    var pid = getProductId();
    var BT = window.BoosterTheme;
    if (BT && BT.swatches && pid) {
      syncBoosterSwatchToVariant(pid, variantId, true);
    }
    var form = getProductForm();
    var idInput = getVariantInput(form);
    if (idInput) {
      idInput.value = variantId;
      idInput.setAttribute('value', variantId);
    }
    scheduleGallerySync();
  }

  function selectVariantFromThumbnail(variantId) {
    rememberUserVariantId(variantId);
    var pid = getProductId();
    var BT = window.BoosterTheme;
    if (BT && BT.swatches && pid) {
      syncBoosterSwatchToVariant(pid, variantId, true);
    }
    syncVariantToForm();
    updateAtcState();
    scheduleGallerySync();
  }







  function getCartProductId() {
    var input = document.querySelector('[data-bstr-variant-input]');
    return input ? String(input.dataset.bstrVariantInput) : null;
  }

  function clearCurrentProductFromCart() {
    var pid = getCartProductId();
    if (!pid || !window.Shopify || !window.Shopify.routes) return Promise.resolve();
    return fetch(window.Shopify.routes.root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var updates = {};
        (cart.items || []).forEach(function(item) {
          if (String(item.product_id) === pid) updates[item.key] = 0;
        });
        if (!Object.keys(updates).length) return;
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates })
        });
      })
      .catch(function() {});
  }







  function shouldUseHandbagVariantFocus() {
    return false;
  }

  function activateHandbagVariantFocus(variantId) {
    document.body.classList.remove('tt-handbag-variant-focus');
    document.documentElement.classList.remove('tt-handbag-variant-focus');
    if (variantId && typeof window.__ttSyncBagPickerVariant === 'function') {
      window.__ttSyncBagPickerVariant(variantId);
    }
    return false;
  }



  function getVariantMatch(vid) {
    for (var i = 0; i < variantMedia.length; i++) {
      if (String(variantMedia[i].id) === String(vid)) return variantMedia[i];
    }
    return null;
  }

  function slideNodes() {
    return document.querySelectorAll('[data-bstr-slide-holder] [data-bstr-slide], [data-bstr-slide-holder] .slide--product');
  }

  function findSlideIndexForVariant(vid) {
    var match = getVariantMatch(vid);
    var slides = slideNodes();
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('data-variant-id') === String(vid)) return i;
      var dv = slides[i].getAttribute('data-variants') || '';
      if (!match || !match.options) continue;
      for (var o = 0; o < match.options.length; o++) {
        var opt = match.options[o];
        if (!opt) continue;
        if (dv.indexOf('|' + opt + '|') >= 0 || dv.indexOf('|' + opt + '#') >= 0) return i;
      }
    }
    return -1;
  }

  function findGalleryNodeForVariant(vid) {
    var match = getVariantMatch(vid);
    var nodes = document.querySelectorAll('.gallery__vertical > [data-variants], .gallery__default [data-variants]');
    for (var i = 0; i < nodes.length; i++) {
      var dv = nodes[i].getAttribute('data-variants') || '';
      if (dv.indexOf(String(vid)) >= 0) return nodes[i];
      if (!match || !match.options) continue;
      for (var o = 0; o < match.options.length; o++) {
        var opt = match.options[o];
        if (!opt) continue;
        if (dv.indexOf('|' + opt + '|') >= 0 || dv.indexOf('|' + opt + '#') >= 0) return nodes[i];
      }
    }
    return null;
  }

  function syncGalleryThumbnails(index) {
    if (index < 0) return;
    document.querySelectorAll('.gallery__thumbnail.bstrSlider__thumb--active').forEach(function(el) {
      el.classList.remove('bstrSlider__thumb--active');
    });
    var thumb = document.querySelector('.gallery__thumbnail[data-bstr-slider-thumb="' + index + '"]');
    if (thumb) thumb.classList.add('bstrSlider__thumb--active');
    syncGalleryVariantLabels();
    lockVariantGalleryHeight();
  }

  function highlightVerticalGallery(node) {
    if (!node) return;
    document.querySelectorAll('.tt-gallery-variant-focus').forEach(function(el) {
      el.classList.remove('tt-gallery-variant-focus');
    });
    node.classList.add('tt-gallery-variant-focus');
    var skipAutoScroll = (window.__ttIsTumblerProduct || window.__ttIsStrawProduct) && window.matchMedia('(max-width: 767px)').matches;
    if (!skipAutoScroll && typeof node.scrollIntoView === 'function') {
      node.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }
  }

  function updateVisibleSlideImage(imageUrl) {
    if (!imageUrl) return false;
    var slider = document.querySelector('[data-bstr-slide-holder]');
    if (!slider) return false;
    var current = parseInt(slider.dataset.bstrSliderCurrent || '0', 10);
    var slides = slideNodes();
    var target = slides[current] || slides[0];
    if (!target) return false;
    var img = target.querySelector('img');
    if (!img) return false;
    img.src = imageUrl;
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    return true;
  }

  function imageStem(url) {
    if (!url) return '';
    var file = url.split('?')[0].split('/').pop().toLowerCase();
    return file.replace(/\.(png|jpe?g|webp|gif)$/i, '');
  }

  function findSlideIndexForImage(imageUrl) {
    var stem = imageStem(imageUrl);
    if (!stem) return -1;

    var slides = document.querySelectorAll('.gallery__default [data-bstr-slide], .slider--product-holder [data-bstr-slide], [data-bstr-slide-holder] [data-bstr-slide]');
    var bestIndex = -1;
    var bestScore = 0;
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      if (!img) continue;
      var slideStem = imageStem(img.currentSrc || img.src || img.dataset.src || '');
      if (!slideStem) continue;
      if (slideStem === stem) return i;
      if (slideStem.indexOf(stem) >= 0 || stem.indexOf(slideStem) >= 0) {
        var score = Math.min(slideStem.length, stem.length);
        if (score > bestScore) {
          bestScore = score;
          bestIndex = i;
        }
      }
    }
    return bestIndex;
  }

  function moveGalleryToIndex(index) {
    if (index < 0) return false;

    var slider = document.querySelector('.gallery__default [data-bstr-slide-holder], .slider--product-holder[data-bstr-slide-holder], [data-bstr-slide-holder]');
    if (!slider) return false;

    var BT = window.BoosterTheme;
    if (BT && BT.PPSlider) {
      BT.PPSlider._moveTo({ index: index, slider: slider });
      BT.PPSlider._moveThumbTo({ index: index });
    } else {
      var thumb = document.querySelector('[data-bstr-slider-thumb="' + index + '"]');
      if (thumb) thumb.click();
    }

    slider.dataset.bstrSliderCurrent = String(index);
    return true;
  }

  function syncProductGallery() {

    var vid = resolveVariantId();
    if (!vid) return;

    var match = getVariantMatch(vid);
    var slideIndex = findSlideIndexForVariant(vid);

    if (slideIndex >= 0) {
      moveGalleryToIndex(slideIndex);
      syncGalleryThumbnails(slideIndex);
    } else if (match && match.image) {
      var index = findSlideIndexForImage(match.image);
      if (index >= 0) {
        moveGalleryToIndex(index);
        syncGalleryThumbnails(index);
      } else {
        updateVisibleSlideImage(match.image);
      }
    }

    highlightVerticalGallery(findGalleryNodeForVariant(vid));
  }

  function scheduleGallerySync() {
    if (document.body.classList.contains('tt-cart-redirecting')) return;
    refreshVariantGalleryUi();
    syncProductGallery();
    var isTumblerMobile = window.__ttIsTumblerProduct && window.matchMedia('(max-width: 767px)').matches;
    var isStrawMobile = window.__ttIsStrawProduct && window.matchMedia('(max-width: 767px)').matches;
    if (isTumblerMobile || isStrawMobile) return;
    [350, 700, 1200].forEach(function(ms) {
      setTimeout(function() {
        refreshVariantGalleryUi();
        syncProductGallery();
      }, ms);
    });
  }

  function installGalleryPurgeObserver() {}




  function getProductForm() {
    var input = document.querySelector('[data-bstr-variant-input]');
    var pid = input && input.dataset ? input.dataset.bstrVariantInput : null;
    if (pid) {
      var byId = document.getElementById('product_form_' + pid);
      if (byId) return byId;
    }
    var byPrefix = document.querySelector('form[id^="product_form_"]');
    if (byPrefix) return byPrefix;
    var pageForm = document.querySelector('#product--page form, .product__page--info form, [data-tt-cap-form]');
    if (pageForm) return pageForm;
    var atc = document.querySelector('.product__atc');
    if (atc) return atc.closest('form');
    return null;
  }

  function getVariantInput(form) {
    form = form || getProductForm();
    if (form && window.__ttIsDollProduct) {
      var dollId = form.querySelector('#tt-doll-id-sync');
      if (dollId) return dollId;
    }
    if (window.__ttIsTumblerProduct) {
      var dock = document.getElementById('tt-tumbler-checkout-dock');
      if (dock) {
        var dockInput = dock.querySelector('[data-bstr-variant-input], input[name="id"]');
        if (dockInput) return dockInput;
      }
    }
    if (form) {
      var inForm = form.querySelector('[data-bstr-variant-input], input[name="id"]');
      if (inForm) return inForm;
    }
    return document.querySelector('[data-bstr-variant-input], input[name="id"]');
  }

  function formHasVariantId(form) {
    var idInput = getVariantInput(form);
    return !!(idInput && idInput.value && idInput.value !== '-1');
  }

  function defaultVariantId() {
    if (variantMedia.length) return String(variantMedia[0].id);
    var form = getProductForm();
    if (window.__ttIsDollProduct && form) {
      var dollSync = form.querySelector('#tt-doll-id-sync');
      if (dollSync && dollSync.value && dollSync.value !== '-1') return String(dollSync.value);
    }
    var idInput = getVariantInput(form);
    var preset = idInput && (idInput.value || idInput.getAttribute('value'));
    if (preset && preset !== '-1') return String(preset);
    return null;
  }

  function syncStickyQtyToForm(form) {
    form = form || getProductForm();
    if (!form) return;
    var stickyQty = document.querySelector('.tt-sticky-bar__qty input[data-qty-input], .tt-sticky-bar__qty input[name="quantity"], .tt-sticky-bar__qty input');
    var formQty = form.querySelector('[data-qty-input], input[name="quantity"]');
    if (stickyQty && formQty) {
      formQty.value = stickyQty.value || 1;
    }
  }

  function getProductId() {
    var input = document.querySelector('[data-bstr-variant-input]');
    if (input && input.dataset.bstrVariantInput) return input.dataset.bstrVariantInput;
    var form = document.querySelector('form[id^="product_form_"]');
    if (form && form.id && form.id.indexOf('product_form_') === 0) {
      return form.id.replace('product_form_', '');
    }
    var stickyBtn = document.querySelector('.tt-sticky-bar__atc[data-buy-button]');
    if (stickyBtn && stickyBtn.dataset.buyButton) return stickyBtn.dataset.buyButton;
    return null;
  }

  function rememberUserVariantId(variantId) {
    if (!variantId || variantId === '-1') return;
    ttUserSelectedVariantId = String(variantId);
  }

  function getActiveSwatchElements() {
    var swatchRoot = document.querySelector('#tt-tumbler-checkout-dock .product__swatches, .product__swatches');
    if (!swatchRoot) return [];
    return Array.prototype.slice.call(
      swatchRoot.querySelectorAll('[data-swatch-option].swatch--active, .swatch--color.swatch--active')
    );
  }

  function normalizeSwatchActives(selectedOption) {
    if (!selectedOption) return;
    var swatchRoot = document.querySelector('.product__swatches');
    if (!swatchRoot) return;
    swatchRoot.querySelectorAll('[data-swatch-option]').forEach(function(el) {
      el.classList.toggle('swatch--active', el.dataset.swatchOption === selectedOption);
    });
    swatchRoot.querySelectorAll('[data-swatch-selected-name]').forEach(function(el) {
      el.textContent = ' - ' + selectedOption;
    });
  }

  function getActiveSwatchElement() {
    var actives = getActiveSwatchElements();
    if (actives.length === 1) return actives[0];
    if (!actives.length) return null;

    if (ttUserSelectedVariantId) {
      var locked = getVariantMatch(ttUserSelectedVariantId);
      var lockedOption = locked && locked.options && locked.options[0];
      if (lockedOption) {
        for (var i = 0; i < actives.length; i++) {
          if (actives[i].dataset.swatchOption === lockedOption) return actives[i];
        }
      }
    }

    var pid = getProductId();
    var BT = window.BoosterTheme;
    if (BT && BT.swatches && pid && BT.swatches.current[pid]) {
      var opts = BT.swatches.current[pid];
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] === false) continue;
        for (var k = 0; k < actives.length; k++) {
          if (actives[k].dataset.swatchOption === opts[j]) return actives[k];
        }
      }
    }

    return null;
  }

  function syncAllVariantInputs(variantId) {
    if (!variantId) return;
    var pid = getProductId();
    document.querySelectorAll('[data-bstr-variant-input], input[name="id"]').forEach(function(input) {
      if (pid && input.dataset && input.dataset.bstrVariantInput && input.dataset.bstrVariantInput !== pid) return;
      input.value = variantId;
      input.setAttribute('value', variantId);
    });
  }

  function readTumblerVariantIdForCheckout(form) {
    form = form || getProductForm();

    if (ttUserSelectedVariantId && getVariantMatch(ttUserSelectedVariantId)) {
      return String(ttUserSelectedVariantId);
    }

    var fromDom = resolveVariantIdFromActiveSwatch();
    if (fromDom) {
      rememberUserVariantId(fromDom);
      return fromDom;
    }

    var pid = getProductId();
    var BT = window.BoosterTheme;
    if (BT && BT.swatches && pid && BT.swatches.current[pid]) {
      var opts = BT.swatches.current[pid];
      if (opts && !opts.includes(false)) {
        var fromBooster = BT.swatches.findVariant(pid);
        if (fromBooster && getVariantMatch(fromBooster)) {
          rememberUserVariantId(fromBooster);
          return String(fromBooster);
        }
      }
    }

    var idInput = getVariantInput(form);
    if (idInput && idInput.value && idInput.value !== '-1') {
      var fromInput = String(idInput.value);
      if (getVariantMatch(fromInput)) return fromInput;
    }

    return null;
  }

  var tumblerAddInFlight = false;

  function addTumblerToCartDirect(event, btn) {
    if (tumblerAddInFlight) return Promise.resolve();
    var form = (btn && btn.closest('form')) || getProductForm();

    if (event) {
      event.preventDefault();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    document.body.classList.add('tt-cart-redirecting');
    syncStickyQtyToForm(form);

    var vid = readTumblerVariantIdForCheckout(form);
    if (!vid || !getVariantMatch(vid)) {
      document.body.classList.remove('tt-cart-redirecting');
      updateAtcState();
      return Promise.resolve();
    }

    rememberUserVariantId(vid);
    syncAllVariantInputs(vid);

    var qtyInput = form && form.querySelector('[data-qty-input], input[name="quantity"]');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    if (btn) {
      btn.disabled = true;
      var label = btn.querySelector('[data-button-text]');
      if (label) label.textContent = 'Adding...';
    }

    tumblerAddInFlight = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: qty }] })
    })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok || (data && data.status === 422)) {
            throw new Error((data && (data.description || data.message)) || 'Could not add to cart');
          }
          return data;
        });
      })
      .then(function() {
        return fetch(root + 'cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        }).then(function(r) { return r.json(); });
      })
      .then(function(cart) {
        tumblerAddInFlight = false;
        if (window.__ttUpdateCartBadges) {
          window.__ttUpdateCartBadges(cart.item_count, true);
        }
        var BT = window.BoosterTheme;
        if (BT && BT.cart && typeof BT.cart.dispatchListeners === 'function') {
          BT.cart.dispatchListeners();
        }
        redirectToCart();
      })
      .catch(function(err) {
        tumblerAddInFlight = false;
        document.body.classList.remove('tt-cart-redirecting');
        if (btn) {
          btn.disabled = false;
          var errLabel = btn.querySelector('[data-button-text]');
          if (errLabel && btn.dataset.originalText) errLabel.textContent = btn.dataset.originalText;
        }
        if (window.alert) {
          window.alert(err && err.message ? err.message : 'Could not add to cart');
        }
      });
  }

  function installTumblerAddCaptureGuard() {
    if (installTumblerAddCaptureGuard._done || !window.__ttIsTumblerProduct) return;
    installTumblerAddCaptureGuard._done = true;

    document.addEventListener('click', function(e) {
      if (!window.__ttIsTumblerProduct) return;
      var btn = e.target.closest('.product__atc [data-buy-button], .tt-sticky-bar__atc[data-buy-button]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      addTumblerToCartDirect(e, btn);
    }, true);

    document.addEventListener('submit', function(e) {
      if (!window.__ttIsTumblerProduct) return;
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains('shopify-product-form')) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      addTumblerToCartDirect(e, form.querySelector('[data-buy-button]'));
    }, true);
  }

  function rememberUserVariantFromUi() {
    var vid = readTumblerVariantIdForCheckout();
    if (vid) {
      rememberUserVariantId(vid);
      return vid;
    }
    return null;
  }

  function prepareTumblerAddToCart(form) {
    if (!window.__ttIsTumblerProduct) return ensureVariantReady(form);
    return !!readTumblerVariantIdForCheckout(form);
  }

  function resolveVariantIdFromActiveSwatch() {
    var active = getActiveSwatchElement();
    if (!active) return null;
    var option = active.dataset.swatchOption;
    var swatchIndex = active.dataset.swatchIndex;
    var optionPos = null;
    if (swatchIndex) {
      var parts = swatchIndex.trim().split('-');
      optionPos = parseInt(parts[parts.length - 1], 10);
    }
    for (var i = 0; i < variantMedia.length; i++) {
      if (!variantMedia[i].options) continue;
      if (optionPos !== null && !isNaN(optionPos)) {
        if (variantMedia[i].options[optionPos] === option) {
          return String(variantMedia[i].id);
        }
        continue;
      }
      if (variantMedia[i].options.indexOf(option) >= 0) {
        return String(variantMedia[i].id);
      }
    }
    return null;
  }

  function resolveVariantId(pid, options) {
    options = options || {};
    pid = pid || getProductId();
    var BT = window.BoosterTheme;
    var form = getProductForm();
    var idInput = form && form.querySelector('[data-bstr-variant-input]');

    if (document.body.classList.contains('tt-cart-redirecting') && ttUserSelectedVariantId) {
      return ttUserSelectedVariantId;
    }

    var fromSwatch = resolveVariantIdFromActiveSwatch();
    if (fromSwatch) {
      rememberUserVariantId(fromSwatch);
      if (!options.skipBoosterSync && !window.__ttIsTumblerProduct && BT && BT.swatches && pid) {
        syncBoosterSwatchToVariant(pid, fromSwatch, true);
      }
      return fromSwatch;
    }

    if (idInput && idInput.value && idInput.value !== '-1') {
      rememberUserVariantId(idInput.value);
      return idInput.value;
    }

    if (BT && BT.swatches && pid && BT.swatches.current[pid]) {
      var opts = BT.swatches.current[pid];
      if (opts && !opts.includes(false)) {
        var found = BT.swatches.findVariant(pid);
        if (found) {
          rememberUserVariantId(found);
          return found;
        }
      }
    }

    var nos = document.querySelector('noscript[data-bstr-preselect][data-bstr-swatch="' + pid + '"]');
    if (nos && nos.dataset.bstrPreselect) return nos.dataset.bstrPreselect;
    return null;
  }

  function syncBoosterSwatchToVariant(pid, variantId, skipIfMatches) {
    if (document.body.classList.contains('tt-cart-redirecting')) return;
    var BT = window.BoosterTheme;
    if (!BT || !BT.swatches || !pid || !variantId) return;
    if (skipIfMatches) {
      var currentVid = BT.swatches.findVariant(pid);
      if (currentVid && String(currentVid) === String(variantId)) return;
    }
    try {
      BT.swatches.setProductVariant(pid, variantId);
    } catch (e) {}
  }

  function syncVariantToForm(form) {
    form = form || getProductForm();
    if (window.__ttIsTumblerProduct && document.body.classList.contains('tt-cart-redirecting') && ttUserSelectedVariantId) {
      syncAllVariantInputs(ttUserSelectedVariantId);
      return true;
    }
    var idInput = getVariantInput(form);
    if (!idInput) return false;

    var pid = idInput.dataset.bstrVariantInput;
    var vid = resolveVariantId(pid);
    if (!vid && formHasVariantId(form)) vid = idInput.value;
    if (!vid) vid = defaultVariantId();

    if (vid) {
      idInput.value = vid;
      idInput.setAttribute('value', vid);
      return true;
    }
    return false;
  }

  function ensureVariantReady(form) {
    form = form || getProductForm();
    if (window.__ttIsTumblerProduct && document.body.classList.contains('tt-cart-redirecting')) {
      return !!(ttUserSelectedVariantId && getVariantMatch(ttUserSelectedVariantId));
    }
    syncStickyQtyToForm(form);

    if (window.__ttIsDollProduct) {
      syncVariantToForm(form);
      var dollInput = getVariantInput(form);
      var dollVid = resolveVariantId() || defaultVariantId();
      if (dollVid && dollInput) {
        dollInput.value = dollVid;
        dollInput.setAttribute('value', dollVid);
        return true;
      }
    }

    return syncVariantToForm(form) || formHasVariantId(form);
  }

  function syncStickyVariantLabel() {
    var label = document.querySelector('.tt-sticky-bar__variant');
    if (!label) return;

    var active = getActiveSwatchElement();
    if (active && active.dataset.swatchOption) {
      var opt = (active.dataset.swatchOption || '').trim();
      if (opt.toLowerCase() === 'default title') {
        label.hidden = true;
        label.textContent = '';
      } else {
        label.hidden = false;
        label.textContent = opt;
      }
    } else if ((label.textContent || '').trim().toLowerCase() === 'default title') {
      label.hidden = true;
      label.textContent = '';
    }
  }

  function updateAtcState() {
    if (window.__ttIsTumblerProduct && document.body.classList.contains('tt-cart-redirecting')) return;
    applyHandbagAtcLabels();
    if (window.__ttIsDollProduct) {
      preselectDollVariant();
      syncDollCheckoutToForm();
      applyDollAtcLabels();
      var dollOk = ensureVariantReady();
      var dollLabel = getDollAtcLabel();
      document.querySelectorAll('.product__atc [data-buy-button]').forEach(function(btn) {
        var label = btn.querySelector('[data-button-text]');
        btn.disabled = !dollOk;
        if (dollOk) {
          btn.removeAttribute('disabled');
          if (label) label.textContent = dollLabel;
        } else if (label) {
          label.textContent = dollLabel;
        }
      });
      return;
    }

    var ok = ensureVariantReady();
    syncStickyVariantLabel();
    var selectText = window.__ttIsHandbagProduct
      ? getHandbagAtcLabel()
      : 'Make a selection';
    try {
      if (!window.__ttIsHandbagProduct && window._bstrLocale && window._bstrLocale.buttons && window._bstrLocale.buttons.select) {
        selectText = window._bstrLocale.buttons.select;
      }
    } catch (e) {}

    document.querySelectorAll('.product__atc [data-buy-button], .tt-sticky-bar__atc[data-buy-button]').forEach(function(btn) {
      var label = btn.querySelector('[data-button-text]');
      var buttonText = window.__ttIsHandbagProduct ? getHandbagAtcLabel() : (btn.dataset.originalText || selectText);
      if (ok) {
        btn.disabled = false;
        btn.removeAttribute('disabled');
        if (label) label.textContent = buttonText;
      } else {
        btn.disabled = true;
        btn.setAttribute('disabled', 'true');
        if (label) label.textContent = selectText;
      }
    });
  }

  function buildDollCartPayload() {
    syncDollCheckoutToForm();
    var vid = parseInt(defaultVariantId(), 10);
    if (!(vid > 0)) vid = parseInt(resolveVariantId(), 10);
    var qty = getDollDockQty();
    if (!(vid > 0) || !(qty > 0)) return null;
    return { items: [{ id: vid, quantity: qty }] };
  }

  var dollAddInFlight = false;

  function addDollProductToCartDirect(event, target) {
    if (dollAddInFlight) return Promise.resolve();
    syncDollCheckoutToForm();
    var payload = buildDollCartPayload();
    if (!payload || !payload.items || !payload.items.length) {
      updateAtcState();
      return Promise.resolve();
    }

    if (event) {
      event.preventDefault();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    var btn = target || (event && event.currentTarget);
    var originalText = '';
    if (btn) {
      btn.disabled = true;
      var label = btn.querySelector('[data-button-text]');
      if (label) {
        originalText = label.textContent;
        label.textContent = 'Adding...';
      }
    }

    dollAddInFlight = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok || (data && data.status === 422)) {
            throw new Error((data && (data.description || data.message)) || 'Could not add to cart');
          }
          return data;
        });
      })
      .then(function() {
        return fetch(root + 'cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        }).then(function(r) { return r.json(); });
      })
      .then(function(cart) {
        dollAddInFlight = false;
        if (window.__ttUpdateCartBadges) {
          window.__ttUpdateCartBadges(cart.item_count, true);
        }
        var BT = window.BoosterTheme;
        if (BT && BT.cart && typeof BT.cart.dispatchListeners === 'function') {
          BT.cart.dispatchListeners();
        }
        document.dispatchEvent(new CustomEvent('booster:cart:add', {
          detail: { item: cart.items[cart.items.length - 1] }
        }));
        if (btn) {
          btn.disabled = false;
          var doneLabel = btn.querySelector('[data-button-text]');
          if (doneLabel && originalText) doneLabel.textContent = originalText;
        }
        redirectToCart();
      })
      .catch(function(err) {
        dollAddInFlight = false;
        if (btn) {
          btn.disabled = false;
          var errLabel = btn.querySelector('[data-button-text]');
          if (errLabel && originalText) errLabel.textContent = originalText;
        }
        var BT = window.BoosterTheme;
        if (BT && BT.cart && typeof BT.cart.error === 'function') {
          BT.cart.error({ message: err && err.message ? err.message : 'Could not add to cart' });
        } else if (window.alert) {
          window.alert(err && err.message ? err.message : 'Could not add to cart');
        }
      });
  }

  function installCartGuard() {
    var BT = window.BoosterTheme;
    if (!BT || !BT.cart || BT.cart.__ttVariantGuard) return;
    BT.cart.__ttVariantGuard = true;

    var origAddJSON = BT.cart.addToCartJSON.bind(BT.cart);
    var origAdd = BT.cart.addToCart.bind(BT.cart);

    function addDollProductToCart(event) {
      return addDollProductToCartDirect(event, event && event.currentTarget);
    }

    BT.cart.addToCart = function(event, form) {
      if (!form && event && event.currentTarget) form = event.currentTarget.closest('form');
      if (!form) form = getProductForm();
      if (window.__ttIsDollProduct) {
        return addDollProductToCart(event);
      }

      if (window.__ttIsTumblerProduct) {
        return addTumblerToCartDirect(event, event && event.currentTarget);
      }

      return origAdd(event, form);
    };

    BT.cart.addToCartJSON = function(event, json, isUpsell) {
      if (!isUpsell && window.__ttIsDollProduct) {
        if (event) {
          event.preventDefault();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        }
        return addDollProductToCartDirect(event, event && event.currentTarget);
      }
      return origAddJSON(event, json, isUpsell);
    };

    var origStickyBuy = null;
    if (BT.ELEMENTS && BT.ELEMENTS.stickyBuy) {
      origStickyBuy = BT.ELEMENTS.stickyBuy.bind(BT.ELEMENTS);
      BT.ELEMENTS.stickyBuy = function(button, event) {
        if (window.__ttIsDollProduct) {
          return addDollProductToCart(event);
        }
        if (window.__ttIsTumblerProduct) {
          return addTumblerToCartDirect(event, button);
        }

        var form = document.getElementById('product_form_' + button.dataset.buyButton) || getProductForm();
        if (window.__ttIsDollProduct) syncDollCheckoutToForm();
        return origStickyBuy(button, event);
      };
      BT.ELEMENTS.__ttStickyPatched = true;
    }
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-buy-button]');
      if (!btn || btn.disabled) return;
    }, true);

    if (BT.events) {
      BT.events.on('booster:variant:select', function(params) {
        if (params && params.selectedVariant) {
          if (params.selectedVariant.id) {
            rememberUserVariantId(params.selectedVariant.id);
            syncAllVariantInputs(params.selectedVariant.id);
          }
          if (params.selectedVariant.options && params.selectedVariant.options[0]) {
            normalizeSwatchActives(params.selectedVariant.options[0]);
          }
        }
        updateAtcState();
        if (!document.body.classList.contains('tt-cart-redirecting')) scheduleGallerySync();
      });
      BT.events.on('booster:variant:deselect', updateAtcState);
    }
  }

  function setFormQty(qty) {
    if (!window.__ttIsHandbagProduct && !window.__ttIsDollProduct) {
      qty = 1;
    }
    if (window.__ttIsDollProduct) {
      qty = parseInt(qty, 10) || 1;
      var dockInput = getDollDockQtyInput();
      if (dockInput) dockInput.value = qty;
      syncDollCheckoutToForm();
      updateAtcState();
      return;
    }
    var form = getProductForm();
    var stickyQty = document.querySelector('.tt-sticky-bar__qty input');
    if (stickyQty) stickyQty.value = qty;
    syncVariantToForm(form);
    updateAtcState();
  }

  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.product__swatches [data-swatch-option]');
    if (swatch && swatch.classList.contains('swatch--active')) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return;
    }
    if (swatch) {
      setTimeout(function() {
        if (document.body.classList.contains('tt-cart-redirecting')) return;
        var form = getProductForm();
        var idInput = getVariantInput(form);
        if (idInput && idInput.value && idInput.value !== '-1') {
          rememberUserVariantId(idInput.value);
          syncAllVariantInputs(idInput.value);
        } else {
          rememberUserVariantFromUi();
        }
        syncVariantToForm();
        updateAtcState();
        scheduleGallerySync();
      }, 0);
      if (!document.body.classList.contains('tt-cart-redirecting')) {
        setTimeout(scheduleGallerySync, 120);
      }
    }
  }, true);

  function applyQuantityFromUrl() {
    if (window.__ttIsDollProduct) {
      var params = new URLSearchParams(window.location.search);
      var dollQty = parseInt(params.get('quantity'), 10);
      setFormQty(dollQty > 0 ? dollQty : 1);
      return;
    }
    if (!window.__ttIsHandbagProduct) {
      setFormQty(1);
      return;
    }
    var params = new URLSearchParams(window.location.search);
    var qtyParam = parseInt(params.get('quantity'), 10);
    if (!(qtyParam > 0)) return;
    setFormQty(qtyParam);
    scheduleGallerySync();
  }

  function applyVariantFromUrl() {
    if (document.body.classList.contains('tt-cart-redirecting')) return false;
    if (window.__ttIsTumblerProduct && ttUserSelectedVariantId) return false;

    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant');
    if (!variantId) return false;

    var BT = window.BoosterTheme;
    var pid = getProductId();
    if (BT && BT.swatches && pid) {
      syncBoosterSwatchToVariant(pid, variantId, false);
    }

    var form = getProductForm();
    var idInput = getVariantInput(form);
    if (idInput) {
      idInput.value = variantId;
      idInput.setAttribute('value', variantId);
    }

    document.querySelectorAll('.gallery__thumbnail[data-variant-id]').forEach(function(thumb) {
      var active = String(thumb.getAttribute('data-variant-id')) === String(variantId);
      thumb.classList.toggle('bstrSlider__thumb--active', active);
      thumb.classList.toggle('is-slot-selected', false);
    });

    selectVariantFromThumbnail(variantId);
    rememberUserVariantId(variantId);
    syncStickyVariantLabel();
    activateHandbagVariantFocus(variantId);
    updateAtcState();
    ttInitialVariantUrlApplied = true;
    return true;
  }

  function installProductInterceptors() {
    if (window.__ttEarlyProductGuard) return;
    window.__ttEarlyProductGuard = true;

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-buy-button], .product__atc [data-buy-button], .tt-sticky-bar__atc[data-buy-button]');
      if (!btn || btn.disabled) return;

      if (window.__ttIsDollProduct) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        syncDollCheckoutToForm();
        addDollProductToCartDirect(e, btn);
        return;
      }

      if (window.__ttIsTumblerProduct) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        addTumblerToCartDirect(e, btn);
        return;
      }

    }, true);

    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains('shopify-product-form')) return;
      if (window.__ttIsDollProduct) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        syncDollCheckoutToForm();
        addDollProductToCartDirect(e, form.querySelector('[data-buy-button]'));
        return;
      }
      if (window.__ttIsTumblerProduct) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        addTumblerToCartDirect(e, form.querySelector('[data-buy-button]'));
        return;
      }
    }, true);
  }

  function initProductCart() {
    installProductInterceptors();
    installTumblerAddCaptureGuard();
    var BT = window.BoosterTheme;
    if (!BT) return;

    if (!applyVariantFromUrl() && BT.swatches && !ttUserSelectedVariantId) {
      var nos = document.querySelector('noscript[data-bstr-preselect][data-bstr-swatch]');
      if (nos) BT.swatches.setProductVariant(nos.dataset.bstrSwatch, nos.dataset.bstrPreselect);
    }

    ensureVariantReady();
    updateAtcState();
    installCartGuard();
    applyQuantityFromUrl();
    scheduleGallerySync();
    initTumblerProductPage();
    initDollProductPage();
  }

  function onAddedToCart() {
    if (window.__ttIsTumblerProduct) return;
    scheduleGallerySync();
    if (!document.documentElement.classList.contains('tt-product-tumbler')) return;
    setTimeout(scrollToTumblerGallery, 80);
    setTimeout(scrollToTumblerGallery, 350);
  }

  function scrollToTumblerGallery() {
    var header = document.querySelector('.page__header');
    var offset = header ? header.getBoundingClientRect().height : 72;
    var gallery = document.querySelector('.gallery__default:not(.hide-mobile), .gallery__vertical:not(.hide-mobile), .gallery__default, .gallery__vertical, .gallery');
    var target = gallery || document.querySelector('.product__row');
    if (!target) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset - 8;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function restoreNativeProductPricing() {
    if (!isSimpleProductPage()) return;
    document.querySelectorAll('[data-product-price]').forEach(function(el) {
      if (el.dataset.ttOriginalPrice) {
        el.textContent = el.dataset.ttOriginalPrice;
      }
    });
    document.querySelectorAll('[data-product-price-sale]').forEach(function(el) {
      if (el.dataset.ttOriginalPrice) {
        el.textContent = el.dataset.ttOriginalPrice;
        if (!el.textContent.trim()) el.style.display = 'none';
      }
    });
    var sticky = document.querySelector('.tt-sticky-bar__price');
    if (sticky && sticky.dataset.ttOriginalPrice) {
      sticky.textContent = sticky.dataset.ttOriginalPrice;
    }
  }

  function fixTumblerMobileGallery() {
    if (!isSimpleProductPage() || window.innerWidth > 767) return;
    var holder = document.querySelector('[data-bstr-slide-holder]');
    if (holder) {
      holder.style.overflow = 'hidden';
      holder.style.maxWidth = '100%';
      holder.style.width = '100%';
    }
    var activeThumb = document.querySelector('.gallery__thumbnail.bstrSlider__thumb--active[data-bstr-slider-thumb]');
    if (!activeThumb) return;
    var idx = parseInt(activeThumb.getAttribute('data-bstr-slider-thumb'), 10);
    if (isNaN(idx)) return;
    var BT = window.BoosterTheme;
    if (BT && BT.PPSlider && typeof BT.PPSlider._moveThumbTo === 'function') {
      try {
        BT.PPSlider._moveThumbTo({ index: idx });
      } catch (e) {}
    }
  }

  function initTumblerProductPage() {
    if (!window.__ttIsTumblerProduct) return;
    restoreNativeProductPricing();
    fixTumblerMobileGallery();
    setTimeout(restoreNativeProductPricing, 300);
  }

  document.addEventListener('booster:cart:add', onAddedToCart);

  document.addEventListener('booster:initialized', function() {
    setTimeout(initProductCart, 50);
    setTimeout(applyVariantFromUrl, 80);
    setTimeout(applyQuantityFromUrl, 120);
    setTimeout(scheduleGallerySync, 120);
    setTimeout(installGalleryPurgeObserver, 150);
    setTimeout(initTumblerProductPage, 160);
    setTimeout(initDollProductPage, 180);
  });

  document.addEventListener('booster:content:update', function() {
    if (window.__ttGalleryRefreshTimer) clearTimeout(window.__ttGalleryRefreshTimer);
    window.__ttGalleryRefreshTimer = setTimeout(function() {
      refreshVariantGalleryUi();
      scheduleGallerySync();
    }, 120);
  });

  document.addEventListener('booster:variant:select', function(e) {
    if (e && e.detail && e.detail.selectedVariant) {
      if (e.detail.selectedVariant.id) {
        rememberUserVariantId(e.detail.selectedVariant.id);
        syncAllVariantInputs(e.detail.selectedVariant.id);
      }
      if (e.detail.selectedVariant.options && e.detail.selectedVariant.options[0]) {
        normalizeSwatchActives(e.detail.selectedVariant.options[0]);
      }
    }
    refreshVariantGalleryUi();
    if (!document.body.classList.contains('tt-cart-redirecting')) scheduleGallerySync();
    fixTumblerMobileGallery();
    restoreNativeProductPricing();
  });

  document.addEventListener('DOMContentLoaded', function() {
    refreshVariantGalleryUi();
    installGalleryPurgeObserver();
    installProductInterceptors();
    applyVariantFromUrl();
    applyQuantityFromUrl();
    scheduleGallerySync();
    initTumblerProductPage();
    initDollProductPage();
    document.addEventListener('tt:handbag-variants-moved', function() {
      refreshVariantGalleryUi();
      scheduleGallerySync();
      if (typeof window.__ttRecenterHandbagGallery === 'function') {
        window.__ttRecenterHandbagGallery();
      }
    });
    [300, 800, 1500].forEach(function(ms) {
      setTimeout(function() {
        refreshVariantGalleryUi();
        updateAtcState();
      }, ms);
    });
    [300, 800].forEach(function(ms) {
      setTimeout(applyVariantFromUrl, ms);
      setTimeout(applyQuantityFromUrl, ms);
      setTimeout(scheduleGallerySync, ms);
    });
  });


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshVariantGalleryUi);
  } else {
    refreshVariantGalleryUi();
  }

  if (window.BoosterTheme) setTimeout(initProductCart, 0);
  installTumblerAddCaptureGuard();

  window.__ttSyncVariant = syncVariantToForm;
  window.__ttGetActiveVariantId = function() {
    if (window.__ttIsTumblerProduct) {
      return readTumblerVariantIdForCheckout() || ttUserSelectedVariantId;
    }
    return ttUserSelectedVariantId || resolveVariantId(null, { skipBoosterSync: true });
  };
  window.__ttUpdateAtcState = updateAtcState;
  window.__ttSyncDollCheckoutToForm = syncDollCheckoutToForm;
  window.__ttInitDollProductPage = initDollProductPage;
  window.__ttBindDollBuyButtons = bindDollBuyButtons;
  window.__ttSwitchDollCharacter = function(payload) {
    if (!window.__ttIsDollProduct || !payload || !payload.variantId) return;
    var variantId = String(payload.variantId);
    ttUserSelectedVariantId = variantId;
    variantMedia = [{
      id: payload.variantId,
      options: payload.options || [],
      image: payload.heroImage || null
    }];
    if (variantMediaEl) variantMediaEl.textContent = JSON.stringify(variantMedia);

    var form = getProductForm();
    var syncFields = ensureDollFormSyncFields(form);
    if (syncFields.id) syncFields.id.value = variantId;

    if (payload.productId) {
      document.querySelectorAll('[data-buy-button]').forEach(function(btn) {
        btn.setAttribute('data-buy-button', String(payload.productId));
      });
      if (form && form.id && form.id.indexOf('product_form_') === 0) {
        form.id = 'product_form_' + payload.productId;
      }
      var variantInput = form && form.querySelector('[data-bstr-variant-input]');
      if (variantInput) variantInput.dataset.bstrVariantInput = String(payload.productId);
    }

    syncDollCheckoutToForm();
    updateAtcState();
  };
  window.__ttSyncProductGallery = syncProductGallery;
})();
